export const MAIN = 'MAIN'
export const PROJECTS = 'PROJECTS'
export const ABOUT = 'ABOUT'
export const CONTACT = 'CONTACT'